import { render, staticRenderFns } from "./GaleriTanimla.vue?vue&type=template&id=b428238a&scoped=true&"
import script from "./GaleriTanimla.vue?vue&type=script&lang=js&"
export * from "./GaleriTanimla.vue?vue&type=script&lang=js&"
import style0 from "./GaleriTanimla.vue?vue&type=style&index=0&id=b428238a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b428238a",
  null
  
)

export default component.exports